export default {
      id: "chevron-md-usage",
      viewBox: "0 0 18 9.95",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#chevron-md",
      toString: function () {
        return this.url;
      }
    }